import React from "react";

import { useSelector } from "react-redux";

// Components

import FormInputGroup from "../../../../UI/FormInputGroup/FormInputGroup";
import TextInput from "../../../../UI/FormInput/TextInput";
import DropDownInput from "../../../../UI/FormInput/DropDownInput";
import CurrencyInput from "../../../../UI/FormInput/CurrencyInput";
import CalendarInput from "../../../../UI/FormInput/CalendarInput";

// Utilities

import { formatDropDownOptions, getCurrentDateMinusDays } from "../../../../../utilities/helper-functions";

// Constants

import { MAX_CURRENCY_INPUT_DIGITS } from "../../../../../config/constants";

export default function Income({formik}) {
  const dropDownOptions = useSelector((state) => state.options.dropDownOptions);

  // const getMinDays = () => {
  //   if (formik?.values?.cliente?.tipoCliente === '2') {
  //     return 90;
  //   } else if (formik?.values?.cliente?.tipoCliente === '1') {
  //     return 30;
  //   }
  // }

  return (
    <>
      <FormInputGroup>
        <CalendarInput
          formik={formik}
          fieldName={`jobReferences.ingreso.fechaConsIng`}
          label={"Fecha de la constancia de ingresos"}
          // minDate={['1', '2'].includes(formik?.values?.cliente?.tipoCliente) ? getCurrentDateMinusDays(getMinDays()) : null}
          maxDate={new Date()}
          isRequired={true}
        />

        <CurrencyInput
          formik={formik}
          fieldName={`jobReferences.ingreso.montoEstimado`}
          label={"Ingresos Mensuales"}
          isRequired={true}
          max={MAX_CURRENCY_INPUT_DIGITS}
        />

        <DropDownInput
          formik={formik}
          fieldName={`jobReferences.ingreso.moneda`}
          label={"Moneda"}
          options={formatDropDownOptions(dropDownOptions?.data?.currencies)}
          isRequired={true}
        />

        <TextInput
          formik={formik}
          fieldName={`jobReferences.ingreso.email`}
          label={"Dirección Email"}
          maxLength={80}
        />

        <DropDownInput
          formik={formik}
          fieldName={`jobReferences.ingreso.otrosIngresos`}
          label={'Actividad generadora de ingresos'}
          options={formatDropDownOptions(dropDownOptions?.data?.otherIncomes)}
          isRequired={true}
        />
      </FormInputGroup>
    </>
  );
}
